import { type BreadCrumbItem } from '@vakantiesnl/types/src';

export type DestinationView = {
	id: string;
	name: string;
	slug: string;
};

type Props = {
	country?: DestinationView;
	region?: DestinationView;
	city?: DestinationView;
};

export const formatGeoBreadcrumbs = ({ country, region, city }: Props): BreadCrumbItem[] => {
	const breadCrumbs = [];

	if (country) breadCrumbs[0] = { text: country.name, to: `/${country.slug}` };
	if (region && country) breadCrumbs[1] = { text: region.name, to: `/${country.slug}/${region.slug}` };
	if (city && region && country)
		breadCrumbs[2] = { text: city.name, to: `/${country.slug}/${region.slug}/${city.slug}` };

	return breadCrumbs;
};
